<template>
  <DashboardTopCardContent
    :callToActionButtonText="$t('L_update_my_plan')"
    @callToActionCallback="updateMyPlan"
  >
    <template #main-content>
      <h2 id="title-h2" class="font-weight-bold text-center">
        {{ $t('L_has_your_debt_situation_changed') }}
      </h2>
      <h4 class="text-center font-weight-medium">
        {{ $t('L_if_so_update_your_debt_plan') }}
      </h4>
    </template>
  </DashboardTopCardContent>
</template>
<script lang="ts">
import { RouteNames } from '@/router/routeNames';
import { defineComponent } from 'vue';
import DashboardTopCardContent from '../../DashboardTopCardContent.vue';
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import { $t } from '@/i18n/i18n.ts';

export default defineComponent({
  name: 'DebtSolutionsCongratsTop',
  components: { DashboardTopCardContent },
  methods: {
    $t,
    async updateMyPlan(this: { $route: RouteLocationNormalizedLoaded; $router: Router }) {
      const route = this.$route;
      const router = this.$router;
      if (route.path !== '/debtsolutions/mydebt') {
        await router.push({ name: RouteNames.MY_DEBT });
      }
    },
  },
});
</script>
